import {
 Avatar,
 Box,
 Button,
 MenuItem,
 Popover,
 TextField,
 Theme,
 Typography,
} from '@mui/material';
import { AuthUser } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import IconUser from '@assets/icons/user.svg?react';

type UserPopoverProps = {
 open: boolean;
 anchorEl: HTMLElement | null;
 onClose: () => void;
 onOpenProfile: () => void;
 user: AuthUser | null;
 databasesList: string[];
 selectedDatabase: string;
 onDatabaseChange: (value: string) => void;
 languages: string[];
 currentLanguage: string;
 onLanguageChange: (value: string) => void;
 onLogout: () => void;
};

const UserPopover = ({
 open,
 anchorEl,
 onClose,
 onOpenProfile,
 user,
 databasesList,
 selectedDatabase,
 onDatabaseChange,
 languages,
 currentLanguage,
 onLanguageChange,
 onLogout,
}: UserPopoverProps) => {
 const { t } = useTranslation();
 return (
  <Popover
   open={open}
   anchorEl={anchorEl}
   onClose={onClose}
   anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right',
   }}
   transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
   }}
  >
   <Box
    sx={(theme: Theme) => ({
     minWidth: 280,
     p: 2,
     display: 'flex',
     flexDirection: 'column',
     backgroundColor: theme.palette.background.paper,
    })}
   >
    <Box
     sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      mb: '20px',
      //   gap: 1,
     }}
    >
     <Avatar
      alt={t('userPopover.avatarAlt')}
      src={new URL('@assets/user.jpg', import.meta.url).href}
      sx={{ width: 60, height: 60, mb: '12px' }}
     />
     <Typography
      variant="subtitle1"
      sx={{ fontWeight: 500, fontSize: 16, mb: '4px' }}
     >
      {user?.name || '-'}
     </Typography>
     <Typography
      variant="body2"
      sx={{
       color: (theme: Theme) => theme.palette.kemek.lightGray,
       fontSize: 14,
      }}
     >
      {user?.email || '-'}
     </Typography>
    </Box>
    <Button
     variant="outlined"
     fullWidth
     size="large"
     onClick={onOpenProfile}
     sx={{
      textTransform: 'none',
      fontWeight: 500,
      mb: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      color: 'primary',
     }}
    >
     {t('userPopover.profileArea')}
     <IconUser style={{ width: 16, height: 16 }} />
    </Button>
    <TextField
     fullWidth
     select
     size="small"
     value={selectedDatabase}
     onChange={(event) => onDatabaseChange(event.target.value)}
     sx={{ mb: '20px' }}
    >
     {databasesList.map((database) => (
      <MenuItem key={database} value={database}>
       {database}
      </MenuItem>
     ))}
    </TextField>
    <Box
     sx={{
      display: 'flex',
      justifyContent: 'space-between',
      //   alignItems: 'center',
      gap: 1,
     }}
    >
     <TextField
      select
      size="small"
      value={currentLanguage}
      onChange={(event) => onLanguageChange(event.target.value)}
      sx={{ minWidth: 80 }}
     >
      {languages.map((language) => (
       <MenuItem key={language} value={language}>
        {language.toUpperCase()}
       </MenuItem>
      ))}
     </TextField>
     <Button
      variant="outlined"
      color="error"
      onClick={onLogout}
      sx={{
       whiteSpace: 'nowrap',
       textTransform: 'none',
      }}
     >
      {t('userPopover.logout')}
     </Button>
    </Box>
   </Box>
  </Popover>
 );
};

export default UserPopover;
